import React from 'react';
import { OverlayTrigger, Tooltip as Btooltip } from 'react-bootstrap';

const Tooltip = ({ text, placement = 'bottom', children }) => {
  if (!text) return children;
  return (
    <OverlayTrigger placement={placement} overlay={<Btooltip>{text}</Btooltip>}>
      {children}
    </OverlayTrigger>
  );
};

export default Tooltip;
